import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineInferencesAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  if (permissions.some((p) => [AuthAuthPermissions.INFERENCE].includes(p))) {
    can('crud', 'Inference')
  }
}
